import { render } from "./MediaForm.vue?vue&type=template&id=3c0d901d"
import script from "./MediaForm.vue?vue&type=script&lang=js"
export * from "./MediaForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\VUE_Tuts\\cybershyft\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__